export default "__VITE_ASSET__fe819fc2__"